import AppTable from '../common/AppTable';
import { ITableColumn } from '../../interfaces/tableProps';
import { theme } from '../../theme';
import { useMemo } from 'react';
import { IProjectOpportunity } from '../../interfaces/projectOpportunity';
import { PROJECT_OPPORTUNITIES_PATH } from '../../router/paths';

const columns: ITableColumn<keyof IProjectOpportunity>[] = [
  {
    name: 'id',
    label: 'ID',
    sx: {
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'underline',
        color: theme.palette.primary.dark
      }
    }
  },
  {
    name: 'customerId',
    label: 'Customer ID',
  },
  {
    name: 'title',
    label: 'Title'
  },
  {
    name: 'overview',
    label: 'Overview'
  }
];

const ProjectOpportunitiesTable = ({ projects, clientId }: {projects: IProjectOpportunity[], clientId: number}) => {
  const handlers: { [key: string]: (val: IProjectOpportunity) => void } = useMemo(() => ({
    id: (p) => window.open(PROJECT_OPPORTUNITIES_PATH + `/${clientId}/${p.id}`, '_blank', 'noopener,noreferrer'),
  }), [clientId]);
  
  return (
    <AppTable
      data={{ list: projects }}
      handlers={handlers}
      columns={columns}
    />
  );
};

export default ProjectOpportunitiesTable;